import React, { useState, useEffect, useLayoutEffect, useRef, useCallback } from 'react';
import { Modal, Tooltip, Pagination, Button, Radio, Image, Dropdown, Steps, DatePicker, Input, Select, Row, Col, InputNumber, Skeleton,  Spin, Form } from 'antd';
import { MinusOutlined, PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import * as com from "../Common.js"
import { Document, Page, pdfjs } from 'react-pdf';
import './BusinessIncomeCalculationModal.css';
import { person } from 'State.js';
import MoneyInput from './Moneyinput.js';
import OverflowInput from './ellipsisInput.js';
import { displayMonthlyIncomeOrLoss } from './Interview1003ViewV2More';
import { track } from 'statsig'
import { STATSIG } from 'statsig/events'
const deepCopy = require('deepcopy')


export default function BusinessIncomeCalculationModalV2(props) {
    pdfjs.GlobalWorkerOptions.workerSrc =
        `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const {
        open, loanId, currentView, onCancel, incomeType, currentEmpData, onApply
    } = props
    // console.log('--------', incomeType, currentEmpData)

    const [inputWidth, setInputWidth] = useState('140px')
    const originalBusinessName = props.businessName || props.application?.[currentView]?.occupation?.employername || currentEmpData?.employername || ""
    const personName = props.personName || `${props.application?.[currentView]?.firstname || ""} ${props.application?.[currentView]?.lastname || ""}`.trim()
    const [showSSN, setShowSSN] = useState(false)
    const [loadingLine, setLoadingLine] = useState({year:null, line:null, loading: false, showReset: false})
    const { Option } = Select
    const [pageWidth, setPageWidth] = useState(0)
    const containerRef = useRef(null)
    const informationRef = useRef(null)
    const manualChangeTimeout = useRef(null)
    const [currentPage, setCurrentPage] = useState(1)
    const isManualChange = useRef(false)
    const isLeftSyncing = useRef(false)
    const isAtBoundary = useRef(false)
    const isSwitching = useRef(false)
    const justSwitched = useRef(false)
    const [visiblePages, setVisiblePages] = useState([])
    const [step, setStep] = useState(0)
    const [status, setStatus] = useState(['process', 'wait'])
    const [fileOptions, setFileOptions] = useState([])
    const [employmentInformation, setEmploymentInformation] = useState([])
    const [form1040schedulec, setForm1040schedulec] = useState([])
    const [tableData, setTableData] = useState([])
    const [years, setYears] = useState([])
    const [originalData, setOriginalData] = useState(null)
    const [numPages, setNumPages] = useState(1)
    const [scale, setScale] = useState(1)
    const [selectFile, setSelectFile] = useState(null)
    const [file, setFile] = useState(null)
    const pageRefs = useRef([])
    const observerRef = useRef(null)
    const [mostRecentYearAverage, setMostRecentYearAverage] = useState('0.00')
    const [twoYearsAverage, setTwoYearsAverage] = useState('0.00')
    const [total1, setTotal1] = useState('0.00')
    const [total2, setTotal2] = useState('0.00')
    const [incomeItems] = useState([{
        name: "",
        index: 0,
    },
    {
        name: "Net profit or loss",
        index: 1
    },
    {
        name: "Nonrecurring income or loss",
        index: 2
    },
    {
        name: "Depletion",
        index: 3
    },
    {
        name: "Depreciation",
        index: 4
    },
    {
        name: "Non-deductible meals & entertainment",
        index: 5
    },
    {
        name: "Business use of home",
        index: 6
    },
    {
        name: "Amortization/Casualty loss/One-time expenses",
        index: 7
    },
    {
        name: "Business miles",
        index: 8
    }
])
    const [selfEmployment, setSelfEmployment] = useState([])
    const [selfEmploymentOriginal, setSelfEmploymentOriginal] = useState([])
    const [selectedRadio, setSelectedRadio] = useState(null)
    const [isEdit, setIsEdit] = useState(false) 
    const [currentPersonIndex, setCurrentPersonIndex] = useState(-1)
    const [isMatch, setIsMatch] = useState(null)
    const [isMatchSSN, setIsMatchSSN] = useState(null)
    const [isMatchYear, setIsMatchYear] = useState(null)
    const [isOpen, setIsOpen] = useState(true);
    const onRadioChange = (e) => {
        console.log(e.target.value)
        setSelectedRadio(e.target.value)
    }
    const refs = useRef({})
    const [form] = Form.useForm()

    useEffect(() => {
        return () => {
            if (manualChangeTimeout.current) {
                clearTimeout(manualChangeTimeout.current)
            }
        }
    }, [])
    useEffect(() => {
        if (open && selectFile) {
            downloadAll([selectFile])
        }
    }, [open, selectFile])
    
    useLayoutEffect (() => {
        if (open) {
            const handleResize = () => {
                if (containerRef.current) {
                    setPageWidth(containerRef.current.offsetWidth - 32)
                }
            }
            setTimeout(handleResize, 0)
            window.addEventListener('resize', handleResize)
            containerRef && containerRef.current && containerRef.current.addEventListener('scroll', handleScroll)
    
            return () => {
                window.removeEventListener('resize', handleResize)
                containerRef && containerRef.current && containerRef.current.removeEventListener('scroll', handleScroll)
            }
        }
    }, [open])

    useEffect(() => {
        if (open) {
            getIncomeData()
            setCurrentPage(1)

        }
    }, [open])
    const isSame = (name1, name2) => {
        const normalize = (str) => str.toLowerCase().replace(/\s+/g, ' ').trim()
        const normalized1 = normalize(name1)
        const normalized2 = normalize(name2)
        const words1 = normalized1.split(' ')
        const words2 = normalized2.split(' ')
        const [shorter, longer] = words1.length <= words2.length ? [words1, words2] : [words2, words1]
        return shorter.every(word => longer.includes(word))
    }
    const findMatchingIndex = (name, array) => {
        const extractName = (str) => str.includes('_') ? str.split('_')[0].trim() : str.trim()
        for (let i = 0; i < array.length; i++) {
            const currentName = extractName(array[i])
            if (isSame(name, currentName)) {
                setCurrentPersonIndex(i)
                return i
            }
        }
        setCurrentPersonIndex(-1)
        return -1
    }
    const findMatchingBusinessIndex = (name, array) => {
        // console.log('findMatchingBusinessIndex-------',name, array)
        return array.findIndex(item => item === name)
    }
    const getFileList = (data) => {
        // console.log('fileList data-------',data)
        const fileList = Object.values(data).flat().reduce((acc, item) => {
            if(item.form1040schedulec && item.form1040schedulec.length > 0) {
                acc.push(...item.form1040schedulec.map((file, index) => ({
                    key: 'form1040schedulec',
                    label: file.File_name || index + 'demo.pdf',
                    value: file.Serial_id
                })))
            }
            return acc
          }, [])
          
          const seenFiles = new Set()
          const uniqueFileList = fileList.filter(file => {
            if (seenFiles.has(file.value)) {
              return false
            }
            seenFiles.add(file.value)
            return true
          })
        // console.log('uniqueFileList-------',uniqueFileList)
        return uniqueFileList
    }
    const incomeMap = {
        'Net profit or loss': {
            label:'Net profit or loss',
            showTooltip: true,
            tooltip: 'Line 31: Enter a profit as a positive number and a loss as a negative number.',},
        'Nonrecurring income or loss': {
            label:'Nonrecurring income or loss',
            showTooltip: true,
            tooltip: `Line 6: Report other income as a negative number unless it's stable, consistent, and recurring. Non-recurring losses or expenses can be added back as positive numbers.`,
        },
        'Depletion': {
            label:'Depletion',
            showTooltip: true,
            tooltip: 'Line 12',
        },
        'Depreciation': {
            label:'Depreciation',
            showTooltip: true,
            tooltip: 'Line 13',    
        },
        'Non-deductible meals & entertainment': {
            label:'Non-deductible meals & entertainment',
            showTooltip: true,
            tooltip: 'Line 24b: Enter the non-deductible portion of meals and entertainment as a positive number; it will be subtracted in the calculation.',
        },
        'Business use of home': {
            label:'Business use of home',
            showTooltip: true,
            tooltip: 'Line 30',
        },
        'Business miles': {
            label:'Business miles',
            showTooltip: true,
            tooltip: 'Line 44a',
        },
        'Miles': {
            label:'Miles',
            showTooltip: false,
            level: 2,
            parent: 'Business miles',
        },
        'Depreciation rate': {
            label:'Depreciation rate',
            showTooltip: false,
            level: 2,
            parent: 'Business miles',
        },
        'Amortization/Casualty loss/One-time expenses': {
            label:'Amortization/Casualty loss/One-time expenses',
            showTooltip: true,
            tooltip: 'Page 2 Part V: Exclude expenses considered the cost of doing business. Review each carefully and only add back allowable amounts, not total expense.',

        }
    }
    const getTotal = (year) => {
        const yearData = tableData.filter(item => item.level !== 2);
        let total = yearData.reduce((sum, item) => {
            // 特殊处理 Nonrecurring income or loss 是 负数
            const value = parseFloat(item[`value${year}`]) || 0;
            if(item.label === 'Non-deductible meals & entertainment' || item.label === 'Nonrecurring income or loss'){
                return sum + value * -1;
                // return sum + value;
            }else{
                return sum + value;
            }
        }, 0);
        // renderDecliningIncomeTag()
        // renderNegativeIncomeTag()
        // 如果是负数的话 用括号展示
        // 处理千分位分隔符
        if(total < 0) {
            let data = total.toFixed(2).replace('-', '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return `(${data})`
        }else{
            return total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
    }
    const addThousandSeparator = (num) => {
        if (typeof num !== 'number') {
            num = parseFloat(num);
            if (isNaN(num)) return '';
        }
        return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    const formatIncomedocuments = (employmentInformation, form1040schedulec, fileList, from) => {
        console.log('formatIncomedocuments-------',employmentInformation, form1040schedulec, fileList, from)
        // 如果没有从接口匹配到employmentInformation，则使用props.currentEmpData
        if(employmentInformation.length === 0) {
            if(from === 'fileMatch') {
                setIsMatch(-1)
            }
        }else{
            setIsMatch(1)
        }
        // console.log('currentEmpData-------',currentEmpData)
        const info = [{
            "name": "Business name",
            "value": currentEmpData.employername || '',
            "type": "text"
        },
        {
            "name": "Name of proprietor",
            "value": "",
            "type": "text"
        },
        {
            "name": "SSN",
            "value": props.borrower.socialsecurity || '',
            "type": "text"
        },
        {
            "name": "Start date",
            "value": currentEmpData.from || '',
            "type": "date"
        },
        // {
        //     "name": "End date",
        //     "value": "",
        //     "type": "date"
        // }
        ]
        setEmploymentInformation(employmentInformation.length > 0 ? employmentInformation.filter(item => item.name !== 'End date') : info)
        // initialize table data
        // 如果1040的length小于2 则复制一项 直到length等于2
        if(form1040schedulec.length === 1) {
            const data = deepCopy(form1040schedulec[0])
            // 重置data的每一项为0
            Object.keys(data).forEach(key => {
                if(key === 'Part V other expenses rows') {
                    data[key] = []
                }else{
                    data[key] = 0
                }
            })
            let fakeData = {
                ...data,
                year: '-',
                show: false,
            }
            form1040schedulec.push(fakeData)
        }
        if(form1040schedulec.length > 2) {
            // 只保留2个
            form1040schedulec = form1040schedulec.slice(0, 2)
        }
        setForm1040schedulec(form1040schedulec)
        const tableData = [];
        const years = form1040schedulec.map(item => item.year)
        setYears(years)
        for (let key in incomeMap) {
            tableData.push({
                label: incomeMap[key].label,
                tooltip: incomeMap[key].tooltip,
                showTooltip: incomeMap[key].showTooltip,
                level: incomeMap[key].level,
                parent: incomeMap[key].parent,
                value1: (parseFloat(form1040schedulec.find(item => item.year === years[0])?.[key] || 0)), // .toFixed(2),
                value2: (parseFloat(form1040schedulec.find(item => item.year === years[1])?.[key] || 0)), // .toFixed(2),
            })
        }
        // 参考tableData的数据结构，遍历Part V other expenses rows中的Description，将Description作为label，Mount作为value1和value2，level取2
        console.log('form1040schedulec-------',form1040schedulec, tableData)
        form1040schedulec.map((item0, index) => {
            item0['Part V other expenses rows'].forEach(item1 => {
                if(!tableData.find(item => item.label === item1.Description)) {
                    tableData.push({
                        label: item1.Description,
                        value1: index === 0 ? item1.Amount : form1040schedulec[1]['Part V other expenses rows'].find(item2 => item2.Description === item1.Description)?.Amount || 0,
                        value2: index === 0 ? form1040schedulec[1]['Part V other expenses rows'].find(item2 => item2.Description === item1.Description)?.Amount || 0 : item1.Amount,
                        level: 2,
                        showTooltip: false,
                        deleted: false,
                        parent: 'Amortization/Casualty loss/One-time expenses',
                    })
                }
            })
        })
        setTableData(tableData);
    }
    const updateParsedData = (parsed_data, name, employerName, newStateValues) => {
        const { employmentInformation, previousEmployment } = newStateValues

        const updatedData = Object.keys(parsed_data).reduce((acc, personName) => {
            if (personName === name) {
                const updatedEmployers = parsed_data[personName].map((employer) => {
                    console.log('employer-------',employer)
                    const employerInfo = employer.employmentInformation.find(
                        (info) => info.name === "Business name" && info.value === employerName
                    )
    
                    employer.form1040schedulec = employer.form1040schedulec.filter(item => item.year !== '-')
                    if (employerInfo) {
                        return {
                            ...employer,
                            employmentInformation,
                            previousEmployment
                        }
                    }
    
                    return employer
                })
    
                acc[personName] = updatedEmployers
            } else {
                acc[personName] = parsed_data[personName]
            }
    
            return acc
        }, {})
    
        return updatedData
    }
    const incomedocumentsRegroup = (file) => {
        let token = sessionStorage.getItem("ZeitroA")
        const name = personName
        const employerName = originalBusinessName;
        const newStateValues = {
            employmentInformation,
        }
        const updatedParsedData = updateParsedData(originalData, name, employerName, newStateValues)
        fetch(`/los/v2/loans/${loanId}/income-documents/regroup`, {
            body: JSON.stringify({ 
                "income_files": updatedParsedData,
                "file_to_change_id": file,
                "new_name_job_file": {
                    [name]: {
                        [employerName]: getKeyByFileserialID(file)
                    }
                }
            }),
            method: 'POST',
            headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            "Content-Type": "application/json"
            }
        }).then(
            response => {
                if (response.status !== 200) {
                    return
                }
                response.json().then(js => {
                    const parsed_data = js.parsed_data
                    setOriginalData(parsed_data)
                    const fileList = getFileList(parsed_data)
                    console.log('fileList-------',fileList)
                    setFileOptions(fileList)
                    const matchedInfo = getMatchedInfo(parsed_data)
                    if (fileList.length > 0 && matchedInfo.employmentInformation.length > 0) {
                        // setSelectFile(fileList[0].value)
                        matchedInfo.form1040schedulec[0] && setSelectFile(matchedInfo.form1040schedulec[0].Serial_id)
                    } else {
                        setSelectFile('')
                    }
                    // const docPersonArr = Object.keys(parsed_data)
                    // const name = personName
                    // const employerName = originalBusinessName;
                    // const finddocPersonIndex = findMatchingIndex(name, docPersonArr)
                    // console.log('finddocPersonIndex-------',finddocPersonIndex, name, employerName, docPersonArr)
                    // if (finddocPersonIndex !== -1) {
                    //     const dynamicKey = docPersonArr[finddocPersonIndex]
                    //     const dynamicDocument = parsed_data[dynamicKey]
                    //     const findEmployerIndex = findMatchingBusinessIndex(employerName, dynamicDocument.map(item => 
                    //         item.employmentInformation.find(info => info.name === "Business name")?.value
                    //     ).filter(Boolean))
                    //     if (findEmployerIndex !== -1) {
                    //         const documentData = dynamicDocument[findEmployerIndex]
                    //         const { employmentInformation,form1040schedulec } = documentData
                    //         console.log('documentData2-------',documentData)
                    //         formatIncomedocuments(employmentInformation, form1040schedulec)
                    //     } else {
                    //         formatIncomedocuments([],[])
                    //     }
                    // } else {
                    //     formatIncomedocuments([],[])
                    // }
                    // console.log('matchedInfo-------',matchedInfo)
                    if(matchedInfo.employmentInformation.length > 0) {
                        const info  = matchedInfo.employmentInformation;
                        if(info.find(item => item.name === 'SSN')?.ssn === props.borrower.socialsecurity) {
                            setIsMatchSSN(1)
                        }else{
                            setIsMatchSSN(-1)
                        }
                        // console.log('info.value-------', currentEmpData.from)
                        // if(info.find(item => item.name === 'Start date')?.value && currentEmpData.from) {
                        //     setIsMatchYear(Number(currentEmpData.from.split('/')[2]) > Number(info.find(item => item.name === 'Start date')?.value.split('/')[2]) ? -1 : 1)
                        // }

                        if(currentEmpData.from && matchedInfo.form1040schedulec.length > 0){
                            const startYear = Number(currentEmpData.from.split('/')[2]);
                            // 从matchedInfo.form1040schedulec中找到year
                            if(matchedInfo.form1040schedulec.find(item => Number(item.year) < Number(startYear))){
                                setIsMatchYear(-1)
                            }else{
                                setIsMatchYear(1)
                            }
                        }else{
                            setIsMatchYear(1)
                        }
                    }else{
                        setIsMatchSSN(1)
                        setIsMatchYear(1)
                    }
                    // formatIncomedocuments(matchedInfo.employmentInformation, matchedInfo.form1040schedulec)
                    formatIncomedocuments( [], matchedInfo.form1040schedulec, fileList, 'fileMatch')
                })
            }
        ).catch(function (err) {
            console.log('err-------',err)
        })
    }
    const downloadAll = (ids) => {

        let token = sessionStorage.getItem("ZeitroA")
        // this.setState({ loading: true })

        fetch(`/los/v2/loans/${loanId}/income-documents/download`, {
            method: 'POST',
            body: JSON.stringify({ DocumentIDs: ids }),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
            "Content-Type": "application/json"
            }
        }).then(async response => {
            // this.setState({ loading: false })
            if (response.status !== 200) {
                setFile(null)
                return;
            }

            await response.json().then(js => {
                let files = js.Documents
                setFile(base64ToArrayBuffer(files[0].Content))
            })
        }).catch(() => {
            setFile(null)
            // this.setState({ loading: false })
        })
    }
    const previewCancel = () => {
        // setExpand(false)
        setStep(0)
        setStatus(['process', 'wait'])
        // 重置数据
        setEmploymentInformation([])
        setForm1040schedulec([])
        setTableData([])
        setSelectFile('')
        setFileOptions([])
        setIsMatch(0)
        setIsMatchSSN(0)
        setIsMatchYear(0)
        
        onCancel()
        if (informationRef.current) {
            informationRef.current.scrollTop = 0
        }
    }
    const onDocumentLoadSuccess = ({ numPages }) => {
        setCurrentPage(1)
        setNumPages(numPages)
        setVisiblePages([1])
    }
    const createObserver = useCallback((entries) => {
        entries.forEach((entry) => {
            const pageNum = parseInt(entry.target.dataset.page, 10)
            if (entry.isIntersecting) {
                setVisiblePages((prevPages) => {
                    if (!prevPages.includes(pageNum)) {
                        return [...prevPages, pageNum]
                    }
                    return prevPages
                })
            }
        })
    }, [])
    useEffect(() => {
        observerRef.current = new IntersectionObserver(createObserver, {
            root: containerRef.current,
            rootMargin: '0px',
            threshold: 0.1
        })

        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        }
    }, [createObserver])
    useEffect(() => {
        if (pageRefs.current.length && observerRef.current) {
            pageRefs.current.forEach((pageRef) => {
                if (pageRef) observerRef.current.observe(pageRef)
            })
        }

        return () => {
            if (observerRef.current) {
                pageRefs.current.forEach((pageRef) => {
                    if (pageRef) observerRef.current.unobserve(pageRef)
                })
            }
        }
    }, [numPages, visiblePages])
    const onChangePage = (page) => {
        isManualChange.current = true

        if (page === 1 || page === numPages) {
            isAtBoundary.current = true
        } else {
            isAtBoundary.current = false
        }
    
        setCurrentPage(page)
        const pdfTargetElement = document.querySelector(`#pdfPage-${page}`)
    
        if (pdfTargetElement) {
            containerRef.current.scrollTo({
                top: pdfTargetElement.offsetTop,
                behavior: 'smooth',
            })
        }
    
        if (manualChangeTimeout.current) {
            clearTimeout(manualChangeTimeout.current)
        }

        manualChangeTimeout.current = setTimeout(() => {
            isManualChange.current = false
        }, 500)
    }
    const resetScrollHandling = () => {
        containerRef.current.removeEventListener('scroll', resetScrollHandling)
        containerRef.current.addEventListener('scroll', handleScroll)
    }
    const handleScroll = () => {
        if (isManualChange.current || isLeftSyncing.current) return
        const scrollTop = containerRef.current.scrollTop
        const containerHeight = containerRef.current.offsetHeight
        const scrollHeight = containerRef.current.scrollHeight
    
        if (handleScroll.lastScrollTop === undefined) {
            handleScroll.lastScrollTop = 0
        }
        handleScroll.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    
        if (justSwitched.current) {
            return
        }
        
        if (isAtBoundary.current) {
            isAtBoundary.current = false
            return
        }

        if (isSwitching.current) return

        if (scrollTop + containerHeight >= scrollHeight - 5) {
            isSwitching.current = true
            changeFile('next')
            setTimeout(() => {
                isSwitching.current = false
            }, 500)
            return
        }
        const anchors = document.querySelectorAll('.pdf-anchor')
        let closestPage = currentPage
        let minDistance = Infinity
    
        anchors.forEach(anchor => {
            const { top } = anchor.getBoundingClientRect()
            const distance = Math.abs(top - containerHeight / 2)
            if (distance < minDistance) {
                minDistance = distance
                closestPage = parseInt(anchor.id.split('-')[1])
            }
        })
    
        if (closestPage !== currentPage) {
            setCurrentPage(closestPage)
        }
    
        setTimeout(() => {
            isLeftSyncing.current = false
        }, 100)
    }
    const changeZoom = (type) => {
        if (type === 'add') {
            setScale(+(Math.min(scale + 0.1, 3).toFixed(1)))
        } else {
            setScale(+(Math.max(scale - 0.1, 0.5).toFixed(1)))
        }
    }
    const removeFileExtension = (fileName) => {
        return fileName && fileName.replace(/\.[^/.]+$/, "")
    }
    const arrayBufferToBlob = (buffer, type) => {
        return new Blob([buffer], { type })
    }
    const changeFile = (type) => {
        const currentIndex = getIndexByValue(selectFile)
        if (type === 'prev' && currentIndex > 0) {
            setSelectFile(fileOptions[currentIndex - 1].value)
            if (refs.current[fileOptions[currentIndex - 1].value]) {
                if (getKeyByFileserialID(fileOptions[currentIndex - 1].value) === 'w2s') {
                    if (informationRef.current) {
                        informationRef.current.scrollTop = 0
                    }
                } else {
                    refs.current[fileOptions[currentIndex - 1].value].scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    })
                }
            }
        } else if (type === 'next' && currentIndex >= 0 && currentIndex < fileOptions.length - 1) {
            setSelectFile(fileOptions[currentIndex + 1].value)
            if (refs.current[fileOptions[currentIndex + 1].value]) {
                if (getKeyByFileserialID(fileOptions[currentIndex + 1].value) === 'w2s') {
                    if (informationRef.current) {
                        informationRef.current.scrollTop = 0
                    }
                } else {
                    refs.current[fileOptions[currentIndex + 1].value].scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    })
                }
            }
        }
    }
    const handleInfoChange = (value, index, type) => {
        setEmploymentInformation((prev) =>
            prev.map((item, i) => {
                if (i === index) {
                    let updatedValue
                    if (type === 'date') {
                        updatedValue = value ? dayjs(value).format('MM/DD/YYYY') : null
                    } else if (type === 'phone') {
                        updatedValue = com.fixPhoneInput(value.target.value)
                    } else if(item.name === 'SSN') {
                        updatedValue = com.fixSSN(value.target.value)
                    } else {
                        updatedValue = value.target.value
                    }
    
                    return {
                        ...item,
                        value: updatedValue,
                    }
                }
                return item
            })
        )
    }
    const stepChange = (value) => {
        // if (value === 1 && (frequency === "" || frequency === undefined || !selectFile || selectFile === '')) {
        //     return
        // }
        const newStatus = status.map((s, index) =>
            index === value ? 'process' : index === 0 ? 'finish' : s
        )
        setStatus(newStatus)
        setStep(value)
    }
    const getStepIcon = (index) => {
        if (status[index] === 'finish') {
            return <img src="/images/income-step-success.svg" />
        }
        return null
    }
    const disabledDate = (current, fieldName, employmentInformation) => {
        if (fieldName === "End date") {
          const startDateValue = employmentInformation.find(
            (info) => info.name === "Start date"
          )?.value
          if (startDateValue) {
            return current && current < dayjs(startDateValue)
          }
          return false
        } else if (fieldName === "Start date") {
          const endDateValue = employmentInformation.find(
            (info) => info.name === "End date"
          )?.value
          if (endDateValue) {
            return current && current > dayjs(endDateValue)
          }
          return false
        }
        return false
    }
    const handleReset = (item0, index0) => {
        // console.log(item0, index0, form1040schedulec)
        // 重置当前行的value1和value2，原始值从form1040schedulec中获取
        let value1 = 0
        let value2 = 0
        form1040schedulec.forEach((item1, index1) => {
            for (let key in item1) {
                if (key === item0.label) {
                    index1 === 0 ? value1 = item1[key] : value2 = item1[key]
                }
            }
        })
        // 重置 level1
        setTableData(prevData => {
            const newData = [...prevData]
            newData[index0] = {
                ...newData[index0],
                value1: value1,
                value2: value2,
            }
            return newData
        })
        // 重置level2
        setTableData(prevData => {
            const newData = [...prevData]
            newData.forEach((item2, index2) => {
                if (item2.parent === item0.label) {
                    let val1 = 0;
                    let val2 = 0;
                    form1040schedulec.forEach((item3, index3) => {
                        item3['Part V other expenses rows'].forEach(item4 => {
                            if (item4.Description === item2.label) {
                                index3 === 0 ? val1 = item4.Amount : val2 = item4.Amount
                            }
                        })
                    })
                    item2.deleted = false
                    item2.value1 = val1
                    item2.value2 = val2
                }
            })
            return newData
        })
    }
    const handleClear = (item, index) => {
        console.log(item, index, form1040schedulec)
        // 清除当前行的value1和value2
        // 特殊处理 Business miles
        if (item.label === 'Miles') {
            setTableData(prevData => {
                const newData = [...prevData]
                const parentIndex = newData.findIndex(i => i.label === 'Business miles')
                newData[parentIndex] = {
                    ...newData[parentIndex],
                    value1: 0,
                    value2: 0,
                }
                return newData
            })
        }
        setTableData(prevData => {
            const newData = [...prevData]
            newData[index] = {
                ...newData[index],
                value1: 0,
                value2: 0,
            }
            return newData
        })
    }
    const handleDelete = (item, index) => {
        console.log(item, index, form1040schedulec)
        // tableData.splice(index, 1)
        // mark the item as deleted
        setTableData(prevData => {
            const newData = [...prevData]
            newData[index].deleted = true
            return newData
        })
        setTimeout(() => {
            calcAmortization(item);
            getTotal(1);
            getTotal(2);
        }, 200)
    }
    const calcAmortization = (item) => {
        // 如果是Amortization/Casualty loss/One-time expenses 则汇总所有parent都是Amortization/Casualty loss/One-time expenses的子项
        if (item.parent === 'Amortization/Casualty loss/One-time expenses') {
            const val1_total = tableData.filter(item => item.parent === 'Amortization/Casualty loss/One-time expenses' && !item.deleted).reduce((acc, curr) => acc + parseFloat(curr.value1), 0)
            const val2_total = tableData.filter(item => item.parent === 'Amortization/Casualty loss/One-time expenses' && !item.deleted).reduce((acc, curr) => acc + parseFloat(curr.value2), 0)
            setTableData(prevData => {
                const newData = [...prevData]   
                const parentIndex = newData.findIndex(i => i.label === 'Amortization/Casualty loss/One-time expenses')
                newData[parentIndex] = {
                    ...newData[parentIndex],
                    value1: val1_total,
                    value2: val2_total
                }
                return newData
            })
        }
    }
    const getLabelByValue = (value) => {
        // console.log('-----', value, fileOptions)
        const option = fileOptions.find((item) => item.value === value)
        return option ? option.label : null
    }
    const getFileIcon = (fileName) => {
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1)
        if (fileExtension === 'pdf') {
            return <img src="/images/pdf-icon.svg" />
        } else {
            return <img src="/images/img-icon.svg" />
        }
    }
    const handleFileChange = (value) => {
        console.log('-----value', value)
        incomedocumentsRegroup(value)
        setSelectFile(value)
        if (refs.current[value]) {
            if (getKeyByFileserialID(value) === 'w2s') {
                if (informationRef.current) {
                    informationRef.current.scrollTop = 0
                }
            } else {
                refs.current[value].scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                })
            }
        }
    }
    const getIndexByValue = (value) => {
        return fileOptions.findIndex((item) => item.value === value)
    }
    const getKeyByFileserialID = (id) => {
        const file = fileOptions.find(item => item.value === id)
        return file ? file.key : null
    }
    const base64ToArrayBuffer = (base64) => {
        const binaryString = atob(base64)
        const len = binaryString.length
        const bytes = new Uint8Array(len)
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }
        return bytes.buffer
    }
    const fileSelectDropdownContent = () => {
        return <Select
            style={{
                width: '314px',
            }}
            getPopupContainer={triggerNode => triggerNode.parentElement}
            className='income-file-select'
            // suffixIcon={<img src='/images/income-select-search.svg' />}
            placeholder="Document name"
            open={isOpen}
            defaultOpen
            value={selectFile}
            onChange={handleFileChange}
        >
            {fileOptions.map(option => (
                <Option key={option.value} value={option.value}>
                    <span style={{ display: 'flex', alignItems: 'center', height: 38 }}>
                        {getFileIcon(option.label)}
                        <div style={{ marginLeft: 8, fontFamily: 'Inter', fontSize: 16, color: '#222', lineHeight: '20px', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{removeFileExtension(option.label)}</div>
                    </span>
                </Option>
            ))}
        </Select>
    }
    const noData = () => {
        return <div className='income-item-nodata'>
            {/* Document unavailable. Please */}
            <Dropdown
                onOpenChange={(visible) => setIsOpen(visible)}
                getPopupContainer={triggerNode => triggerNode.parentElement}
                trigger={['click']}
                dropdownRender={fileSelectDropdownContent}
                placement="bottomLeft"
            >
                <div style={{ width: 28, height: 28, marginRight: 8, marginLeft: 0 }} className='income-calculation-select-file'><img style={{ width: 22, height: 22 }} src='/images/income-file.svg'/></div> 
            </Dropdown>
            add relevant documents.
        </div>
    }
    const getIncomeData = () => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch(`/los/v2/loans/${loanId}/income-1040-schedule-c`, {
            body: JSON.stringify({}),
            method: 'POST',
            headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            "Content-Type": "application/json"
            }
        }).then(
            response => {
                if (response.status !== 200) {
                    return
                }
                response.json().then(js => {
                    const parsed_data = js.parsed_data
                    setOriginalData(parsed_data)
                    const fileList = getFileList(parsed_data)
                    console.log('fileList-------',fileList)
                    setFileOptions(fileList)
                    const matchedInfo = getMatchedInfo(parsed_data)
                    if (fileList.length > 0 && matchedInfo.employmentInformation.length > 0) {
                        // setSelectFile(fileList[0].value)
                        matchedInfo.form1040schedulec[0] && setSelectFile(matchedInfo.form1040schedulec[0].Serial_id)
                    } else {
                        setSelectFile('')
                    }
                    if(matchedInfo.employmentInformation.length > 0) {
                        const info  = matchedInfo.employmentInformation;
                        if(info.find(item => item.name === 'SSN')?.ssn === props.borrower.socialsecurity) {
                            setIsMatchSSN(1)
                        }else{
                            setIsMatchSSN(-1)
                        }
                        // console.log('info.value-------', currentEmpData.from)
                        // if(info.find(item => item.name === 'Start date')?.value && currentEmpData.from) {
                        //     setIsMatchYear(Number(currentEmpData.from.split('/')[2]) > Number(info.find(item => item.name === 'Start date')?.value.split('/')[2]) ? -1 : 1)
                        // }

                        if(currentEmpData.from && matchedInfo.form1040schedulec.length > 0){
                            const startYear = Number(currentEmpData.from.split('/')[2]);
                            // 从matchedInfo.form1040schedulec中找到对应的year
                            if(matchedInfo.form1040schedulec.find(item => Number(item.year) < Number(startYear))){
                                setIsMatchYear(-1)
                            }else{
                                setIsMatchYear(1)
                            }
                        }else{
                            setIsMatchYear(1)
                        }
                    }else{
                        setIsMatchSSN(1)
                        setIsMatchYear(1)
                    }
                    // console.log('matchedInfo-------',matchedInfo)
                    formatIncomedocuments(matchedInfo.employmentInformation, matchedInfo.form1040schedulec, fileList)
                })
            }
        ).catch(function (err) {
            
        })
    }
    const matchBusinessIndex = (personData) => {
        console.log('personData', personData)
        const businessName = originalBusinessName;
        let person_index = -1;
        personData.forEach((item, index) => {
            if(item.employmentInformation.find(info => info.name === "Business name" || info.name === "Employer name")?.value === businessName) {
                person_index = index
            }
        })
        return person_index
    }
    const postIncomeData = (params) => {
        let token = sessionStorage.getItem("ZeitroA")
        const personName = Object.keys(originalData)[currentPersonIndex]
        const param = deepCopy(originalData);
        let businessIndex = -1;
        for(let person in param){
            if(person == personName) {
                businessIndex = matchBusinessIndex(param[person])
                if(businessIndex !== -1) {
                    param[person][businessIndex] = params
                }
            }
        }
        console.log('post income params', param, businessIndex, personName)
        fetch(`/los/v2/loans/${loanId}/income-calculation-selfemp`, {
            body: JSON.stringify({
                modified_data: param
             }),
            method: 'POST',
            headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            "Content-Type": "application/json"
            }
        }).then(
            response => {
                if (response.status !== 200) {
                    return
                }
                response.json().then(js => {
                    // console.log('post income js-------',js)
                    // 获取第二步数据
                    // getSelfEmployment()
                    // 找出匹配的人名
                    let name = '';
                    for(let key in js.parsed_data){
                        if(key === personName){
                            name = key
                        }
                    }
                    name && calcSelfEmployment(js.parsed_data[name][businessIndex].form1040schedulec, js.parsed_data[name][businessIndex])
                    stepChange(step + 1)
                    if (name) {
                        track(STATSIG.LOAN.INCOME_CALCULATION, 'calculation_result', {
                            type: 'calculation_result',
                            kind: 'self_employed',
                            section: incomeType,
                        })
                    }
                })
            }
        ).catch(function (err) {
            
        })
    }
    const postSelfEmployment = (yearIndex) => {
        console.log('postSelfEmployment-------',yearIndex, selfEmployment)
        // const filterSelfEmployment = selfEmployment.filter(item => item.year !== '-');
        let token = sessionStorage.getItem("ZeitroA")
        const personName = Object.keys(originalData)[currentPersonIndex];
        const params = deepCopy(originalData);
        let businessIndex = -1;
        for(let person in params){
            if(person === personName){
                // 拼装数据
                businessIndex = matchBusinessIndex(params[person])
                params[person][businessIndex].form1040schedulec = selfEmployment
                // deepCopy(selfEmployment).map(yearData => {
                //     for(let item in yearData){
                //         console.log('name-------',item, yearData[item])
                //         if(['Net profit or loss','Nonrecurring income or loss'].includes(item)){
                //             yearData[item] = Number(yearData[item]) < 0 ? '(' + yearData[item].toString().replace('-', '') + ')' : yearData[item]
                //         }
                //     }
                //     return yearData
                // })  
            }
        }
        console.log('selfEmployment params-------',params)
        fetch(`/los/v2/loans/${loanId}/income-calculation-selfemp`, {
            body: JSON.stringify({
                modified_data: params
             }),
            method: 'POST',
            headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            "Content-Type": "application/json"
            }
        }).then(
            response => {
                if (response.status !== 200) {
                    return
                }
                response.json().then(js => {

                    console.log('selfEmployment-------',js, loadingLine)
                    setLoadingLine(prev => ({
                        ...prev,
                        loading: false
                    }))
                    setTimeout(() => {
                        setLoadingLine({year: null, line: null, loading: false, showReset: false})
                    // 找出匹配的人名
                    let name = '';
                    for(let key in js.parsed_data){
                        if(key === personName){
                            name = key
                        }
                    }
                    name && calcSelfEmployment(js.parsed_data[name][businessIndex].form1040schedulec, js.parsed_data[name][businessIndex])
                    }, 2000)
                })
            }
        ).catch(function (err) {
            
        })
    }
    const transToNumber = (value) => {
        // 如果是（）负数 则去掉括号 添加-号
        if(value.toString().startsWith('(') && value.toString().endsWith(')')){
            value = value.toString().replace('(', '').replace(')', '')
            value = '-' + value
        }
        // 去除所有非数字字符(除了负号和小数点)
        const cleanValue = value.toString().replace(/[^\d.-]/g, '')
        return cleanValue
    }
    const update1003 = () => {
        const income = selectedRadio === 1 ? transToNumber(mostRecentYearAverage) : transToNumber(twoYearsAverage)
        if (typeof onApply === "function") {
            onApply({
                kind: "selfemp",
                incomeType,
                income,
            })
        }
        previewCancel()
    }
    const footer = step === 0 ? [
        <div></div>,
        <Button className="income-btn-confirm" type="primary" 
        disabled={form1040schedulec.length === 0}
        // disabled={frequency === "" || frequency === undefined || !selectFile || selectFile === ''}
         onClick={() => saveData()}>Continue</Button>
    ] : [
        <Button className="income-btn-back" type='link' onClick={() => stepChange(step - 1)}>Back</Button>,
        <div>
            <Button className="income-btn-confirm" type="primary" disabled={selectedRadio === null} onClick={update1003}>Update to 1003</Button>
        </div>
    ]
    const resetValue = (yearIndex, fieldName) => {
        console.log('resetValue-------',yearIndex, fieldName)
        // console.log('selfEmploymentOriginal-------',selfEmployment, selfEmploymentOriginal)
        const updatedScheduleC = [...selfEmployment];
        updatedScheduleC[yearIndex][fieldName] = selfEmploymentOriginal[yearIndex][fieldName];
        setSelfEmployment(updatedScheduleC);
        setIsEdit(false)
        setLoadingLine(prev => ({
            ...prev,
            showReset: false
        }))
    }
    const formatData = (str) => {
        // 如果str是负数 则用括号展示
        if(str < 0) {
            return `(${parseFloat(str).toFixed(2).replace('-', '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')})`
        }else{
            return parseFloat(str).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
    }
    const calcSelfEmployment = (js, matchedInfo) => {
        // 计算每年的总调整额
        const updatedScheduleC = js.map((yearData, year_index) => {
            // 获取所有需要计算的字段值
            const netProfit = parseFloat(yearData["Net profit or loss"] || 0);
            const nonrecurring = parseFloat(yearData["Nonrecurring income or loss"] || 0);
            const depletion = parseFloat(yearData["Depletion"] || 0);
            const depreciation = parseFloat(yearData["Depreciation"] || 0);
            const meals = parseFloat(yearData["Non-deductible meals & entertainment"] || 0);
            const homeUse = parseFloat(yearData["Business use of home"] || 0);
            const oneTimeExpenses = parseFloat(yearData["Amortization/Casualty loss/One-time expenses"] || 0);
            const businessMiles = parseFloat(yearData["Business miles"] || 0);
            // if(year_index === 0) {
                // setTotal1(parseFloat(yearData["Total Adjustments"] || 0));
            // }else{
                // setTotal2(parseFloat(yearData["Total Adjustments"] || 0));
            // }
            // 计算总调整额
            const totalAdjustments = netProfit + 
                (nonrecurring * -1) + // 非经常性收入/损失通常是减项
                // nonrecurring + // 非经常性收入/损失通常是减项
                depletion + 
                depreciation + 
                meals + 
                homeUse + 
                oneTimeExpenses + 
                businessMiles;

            
            return {
                ...yearData,
                "Total Adjustments": Number(totalAdjustments).toFixed(2).toString()
            };
        });

        console.log('updatedScheduleC-------',updatedScheduleC)
        
        setSelfEmployment(updatedScheduleC);

        setSelfEmploymentOriginal(deepCopy(updatedScheduleC))

        setMostRecentYearAverage(formatData(matchedInfo['Monthly Income: \nmost recent year average']))
        setTwoYearsAverage(formatData(matchedInfo['Monthly Income: \ntwo years average']))
        
        // 更新总计和平均值
        if (updatedScheduleC.length > 0) {
            // 最近一年的总额
            const mostRecentYear = updatedScheduleC[updatedScheduleC.length - 1];
            const mostRecentTotal = parseFloat(mostRecentYear["Total Adjustments"] || 0);
            // setTotal1(mostRecentTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            
            // 计算月平均收入 (最近一年)
            const monthlyAverage = (mostRecentTotal / 12).toFixed(2);
            // setMostRecentYearAverage(monthlyAverage);
            
            // 如果有两年数据，计算两年平均
            if (updatedScheduleC.length >= 2) {
                const twoYearsTotal = updatedScheduleC.reduce((sum, year) => 
                    sum + parseFloat(year["Total Adjustments"] || 0), 0);
                // setTotal2(twoYearsTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                
                // 计算月平均收入 (两年)
                const twoYearsMonthlyAverage = (twoYearsTotal / (12 * updatedScheduleC.length)).toFixed(2);
                // setTwoYearsAverage(twoYearsMonthlyAverage);
            }
        }

    }
    // Calculate total for each year
    const calcTotal = (yearIndex) => {
        console.log('calcTotal-------',yearIndex)
        // Get all income items for current year
        const yearData = selfEmployment[yearIndex];
        if (!yearData) return;

        // Calculate sum of all income items
        const total = incomeItems.reduce((sum, item) => {
            // Skip first item (title row)
            if (item.name === '') return sum;
            
            // Convert string to number and add
            const value = parseFloat(yearData[item.name] || 0);
            if(item.name === 'Non-deductible meals & entertainment' || item.name === 'Nonrecurring income or loss'){
                return sum + (isNaN(value) ? 0 : value * -1);
                // return sum + (isNaN(value) ? 0 : value);
            }else{
                return sum + (isNaN(value) ? 0 : value);
            }
        }, 0);

        // Format result with 2 decimal places
        let formattedTotal = total.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        // 如果是负数的话 用括号展示
        if(total < 0) {
            let data = formattedTotal.replace('-', '');
            formattedTotal = `(${data})`
        }

        // Update corresponding total value based on year index
        if (yearIndex === 0) {
            setTotal1(formattedTotal);
        } else {
            setTotal2(formattedTotal);
        }
    }
    // Call calcTotal on component initialization and data updates
    useEffect(() => {
        if (selfEmployment.length > 0) {
            // Calculate total for first year
            calcTotal(0);
            // Calculate total for second year if data exists
            if (selfEmployment.length > 1) {
                calcTotal(1);
            }
        }
    }, [selfEmployment]);

    // Save business information and form1040schedulec data
    const saveData = () => {
        console.log('saveData-------',form1040schedulec, employmentInformation, tableData)
        // 检查数据是否都符合规则
        const checkData = () => {
            let flag = true
            tableData.forEach(data => {
                if(!['Net profit or loss', 'Nonrecurring income or loss'].includes(data.label)){
                    if(Number(data.value1) < 0 || Number(data.value2) < 0){
                        flag = false
                    }
                }
            })
            return flag
        }
        // console.log('checkData-------',checkData())
        if(!checkData()){
            return
        }
        const params = {
            employmentInformation: {},
            form1040schedulec: []
        }
        // Save business information
        params.employmentInformation = employmentInformation
        // Convert tableData back to 1040schedulec structure and submit to API
        years.forEach((year, index) => {
            const data = {
                year: year,
                "Part V other expenses rows": []
            }
            tableData.forEach(item => {
                if (['Net profit or loss', 'Nonrecurring income or loss', 'Depletion', 'Depreciation', 'Non-deductible meals & entertainment', 'Business use of home', 'Business miles','Miles', 'Depreciation rate', 'Amortization/Casualty loss/One-time expenses'].includes(item.label)){
                    data[item.label] = item[index === 0 ? 'value1' : 'value2'].toString()
                }else{
                    const partData ={
                        Description: item.label,
                        Amount: item[index === 0 ? 'value1' : 'value2'].toString(),  
                    }
                    if(!data["Part V other expenses rows"].find(i => i.Description === item.label)  ){
                        data["Part V other expenses rows"].push(partData)
                    }
                }
            })
            params.form1040schedulec.push(data);
        })
        console.log('params-------',params)
        postIncomeData(params)
    }

    const formatNumber = (value, label) => {
        let data = parseFloat(value);
        if(data !== 0) {
            data = data.toFixed(2)
        }
        data = data.toString()

        if(Number(value) < 0 || label === "Non-deductible meals & entertainment") {
            return `(${data.replace('-', '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')})`
        }else{
            return data.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
    }
    const current1003Input = formatNumber(
        (currentEmpData?.selfemployed
            ? displayMonthlyIncomeOrLoss(currentEmpData)
            : currentEmpData?.incomeorloss) || 0,
        'income'
    );

    const getMatchedInfo = (parsed_data) => {
        const docPersonArr = Object.keys(parsed_data)
        // 第一步匹配人名
        const name = personName
        const businessName = originalBusinessName;
        console.log('------businessName', businessName, props.application[currentView])
        const finddocPersonIndex = findMatchingIndex(name, docPersonArr)
        if (finddocPersonIndex !== -1) {
            // 第二步匹配公司名
            const dynamicKey = docPersonArr[finddocPersonIndex]
            const dynamicDocument = parsed_data[dynamicKey]
            const findBusinessIndex = findMatchingBusinessIndex(businessName, dynamicDocument.map(item => 
                item.employmentInformation.find(info => info.name === "Business name" || info.name === "Employer name")?.value
            ).filter(Boolean))
            if (findBusinessIndex !== -1) {
                // 第三步匹配数据
                const documentData = dynamicDocument[findBusinessIndex]
                // const { employmentInformation, form1040schedulec } = documentData
                // console.log('documentData-------',documentData)
                // formatIncomedocuments(employmentInformation, form1040schedulec )
                return documentData
            } else {
                return {
                    employmentInformation: [],
                    form1040schedulec: []
                }
                // formatIncomedocuments([], [])
            }
        } else {
            // formatIncomedocuments([], [])
            return {
                employmentInformation: [],
                form1040schedulec: []
            }
        }
    }

    const createImageURLFromBase64 = (arrayBuffer, type) => {
        const blob = arrayBufferToBlob(arrayBuffer, type)
        return URL.createObjectURL(blob)
    }

    const handleScheduleCFieldItemChange = (index, field, value, item, ...args) => {

        // console.log('item', item)
        // console.log('args', args)
        // console.log('index', index)
        // console.log('field', field)
        // 移除所有非数字字符(除了负号和小数点)
        // const cleanValue = value.toString().replace(/[^\d.-]/g, '')
        const numValue = Number(value).toFixed(2) // parseFloat(cleanValue)

        setTableData(prevData => {
            const newData = [...prevData]
            
            // 如果输入无效,保持原值
            if (isNaN(numValue)) {
                return newData
            }

            // 更新对应字段的值
            newData[index] = {
                ...newData[index],
                [field]: numValue // .toFixed(2)
            }

            return newData
        })


        
        // 如果有parent字段 更新parent对应的value1或者value2
        if (item.parent) {
            console.log('item.parent-------',item.parent, tableData, index)
            // 如果是Business miles 则需要乘以Depreciation rate
            if (item.parent === 'Business miles') {
                // const parent = tableData.find(i => i.label === 'Business miles')
                const rate = tableData.find(i => i.label === 'Depreciation rate')
                const res = numValue * (rate[field] || 0)
                setTableData(prevData => {
                    const newData = [...prevData]
                    const parentIndex = newData.findIndex(i => i.label === 'Business miles')
                    // console.log('parentIndex-------',parentIndex, newData, prevData, res)
                    newData[parentIndex] = {
                        ...newData[parentIndex],
                        [field]: res.toFixed(2)
                    }
                    return newData
                })
            }
            // 如果是Amortization/Casualty loss/One-time expenses 则汇总所有parent都是Amortization/Casualty loss/One-time expenses的子项
            if (item.parent === 'Amortization/Casualty loss/One-time expenses') {
                // const parent = tableData.find(i => i.label === 'Amortization/Casualty loss/One-time expenses')
                const updatedTableData = [...tableData];
                updatedTableData[index] = {
                    ...updatedTableData[index],
                    [field]: numValue
                };
                const res = updatedTableData.filter(item => item.parent === 'Amortization/Casualty loss/One-time expenses' && !item.deleted).reduce((acc, curr) => acc + parseFloat(curr[field]), 0);
                // console.log('res-------Amortization/Casualty loss/One-time expenses', res, updatedTableData.filter(item => item.parent === 'Amortization/Casualty loss/One-time expenses' && !item.deleted));
                setTableData(prevData => {
                    const newData = [...prevData];
                    const parentIndex = newData.findIndex(i => i.label === 'Amortization/Casualty loss/One-time expenses');
                    newData[parentIndex] = {
                        ...newData[parentIndex],
                        [field]: res
                    };
                    return newData;
                });
            }

        }

        // recalculate the total
        getTotal(index + 1);

    }

    // 添加一个处理输入值的函数
    const handleInputValue = (value, label) => {
        if (!value) return 0;
        
        // 移除所有逗号
        let cleanValue = value.toString().replace(/,/g, '');
        
        // 检查是否有括号
        if (cleanValue.startsWith('(') && cleanValue.endsWith(')')) {
            // 移除括号并将其转换为负数
            cleanValue = cleanValue.slice(1, -1);
        }
        
        // 转换为数字
        const numValue = Number(cleanValue);
        return isNaN(numValue) ? 0 : numValue;
    }

    // 格式化显示值的函数
    const formatDisplayValue = (value, label) => {
        if (!value && value !== 0) return '';

        if(label !== 'Nonrecurring income or loss') {
            // 这个场景需要替换-号和括号输入
        }
        
        const numValue = Number(value);
        const isNegative = numValue < 0;
        const absValue = Math.abs(numValue);

        
        // 格式化为带两位小数的字符串
        // 如果是负数要带括号展示
        // if(isNegative) {
        //     return `(${absValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')})`
        // } else {
        //     return absValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        // }  
        // 展示千分位分隔符 
        return String(numValue).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }


    /**
     * 用于根据 years 数据判断是否有 “-” 项，若有则显示 “Insufficient history” 标签
     */
    const renderInsufficientHistoryTag = (years) => {
        return years.filter(item => item === '-').length > 0
            ? <span className="income-tag">Insufficient history</span>
            : '';
    }

    const renderMissingDocumentTag = () => {
        return fileOptions.length === 0 ? <span className="income-tag">Missing document</span> : '';
    }

    const getTotalNumber = (year) => {
        const yearData = tableData.filter(item => item.level !== 2);
        let total = yearData.reduce((sum, item) => {
            // 特殊处理 Nonrecurring income or loss 是 负数
            const value = parseFloat(item[`value${year}`]) || 0;
            if(item.label === 'Non-deductible meals & entertainment' || item.label === 'Nonrecurring income or loss'){
                return sum + value * -1;
                // return sum + value;
            }else{
                return sum + value;
            }
        }, 0);
        return total;
    }

    const renderDecliningIncomeTag = () => {
        if(years.filter(item => item === '-').length > 0){return ''}
        if(getTotalNumber(1)< 0 || getTotalNumber(2)< 0){return ''}
        // 如果getTotalNumber（1）小于 getTotalNumber（2）
        if(getTotalNumber(1) < getTotalNumber(2)){
            return <span className="income-tag">Declining income</span>
        }
        return '';
    }

    const renderNegativeIncomeTag = () => {
        if(years.filter(item => item === '-').length > 0){return ''}
        // 如果getTotal（1）和getTotal（2）有一个包含括号，则显示Negative income
        if(getTotalNumber(1)< 0 || getTotalNumber(2)< 0){
            return <span className="income-tag">Negative income</span>
        }
        return '';
    }

    const renderDecliningIncomeTag2 = () => {
        if(years.filter(item => item === '-').length > 0){return ''}
        // 如果total1小于 total2
        const data1 = total1.replace(/,/g, '').replace(/\(/g, '-').replace(/\)/g, '');
        const data2 = total2.replace(/,/g, '').replace(/\(/g, '-').replace(/\)/g, '');
        if(Number(data1) < 0 || Number(data2)< 0){return ''}

        if(Number(data1) < Number(data2)){
            return <span className="income-tag">Declining income</span>
        }
        return '';
    }

    const renderNegativeIncomeTag2 = () => {
        if(years.filter(item => item === '-').length > 0){return ''}

        // 如果total1和total2有一个包含括号，则显示Negative income
        const data1 = total1.replace(/,/g, '').replace(/\(/g, '-').replace(/\)/g, '');
        const data2 = total2.replace(/,/g, '').replace(/\(/g, '-').replace(/\)/g, '');
        if(Number(data1) < 0 || Number(data2)< 0){
            return <span className="income-tag">Negative income</span>
        }
        return '';
    }

    return (
        <>
            <Modal
                className={`income-calculation-modal2 check-list`}
                styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.75)' } }}
                maskClosable={false}
                width={window.innerWidth > 1400 ? '90%' : '96%'}
                open={open}
                title=""
                onCancel={previewCancel}
                footer={footer}
                destroyOnClose={true}
            >
                <div className='preview-modal-top'>Income calculation</div>
                <div style={{flex: step === 0 ? 1 : 'none', display: 'flex', flexDirection: 'column'}}>
                    <div span={24}>
                        <div className='income-calculation-steps-wrapper'>
                            <Steps
                                className='income-calculation-steps'
                                size="small"
                                current={step}
                                // onChange={(value) => {
                                //     if(value === 1){
                                //         return
                                //     }
                                //     stepChange();
                                // }}
                                items={[
                                    {
                                        title: 'Information',
                                        icon: getStepIcon(0),
                                    },
                                    {
                                        title: 'Calculation',
                                        icon: getStepIcon(1),
                                    }
                                ]}
                            />
                            {/* {step === 1 && <div style={{fontSize: 16, fontWeight: 600, color: '#325CEB', lineHeight: 'normal', display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer'}}><img style={{width: 22, height: 22}} src='/images/document-download-blue.svg'/> Download worksheet</div> } */}
                        </div>
                    </div>
                    <div style={{display: step === 0 ? 'block' : 'none'}} span={24}>
                        <div className='income-calculation-step-title'>
                            Review the numbers scanned by AI from the document and edit if needed before proceeding to the next calculation.
                        </div>
                    </div>

                    {/* step 1 -- information */}
                    {/* eddit info */}
                    <div style={{display: 'flex', flex: 1, overflowX: 'scroll', paddingBottom: 14}}>
                        <div style={{ display: step === 0 ? 'block' : 'none', flex: 1}} span={12}>
                            <div style={{padding: '0 34px 24px 50px'}} ref={informationRef} className='income-calculation-content'>
                                {/* business information */}
                                {
                                // props.application[currentView].occupation.percentownership > 24 && 
                                (
                                    <div className='income-item'>
                                        <div className='income-item-title'>Business information</div>
                                        {
                                            employmentInformation.length > 0 ? (
                                                employmentInformation.map((item, index) => (
                                                    <Row className='income-item-content' gutter={10} key={index}>
                                                        <Col>
                                                            <div className='income-item-label'>{item.name}</div>
                                                        </Col>
                                                        <Col style={{display: 'flex', alignItems: 'center'}}>
                                                            <div style={{width: 240}}>
                                                                {item.type === 'date' ? 
                                                                    <DatePicker
                                                                        style={{
                                                                            width: '100%'
                                                                        }}
                                                                        className='income-date wages-date'
                                                                        disabledDate={(current) =>
                                                                            disabledDate(current, item.name, employmentInformation)
                                                                        }
                                                                        placeholder="MM/DD/YYYY"
                                                                        format="MM/DD/YYYY"
                                                                        // allowClear={false}
                                                                        // prefix={<img style={{width: 14, height: 14}} src="/images/income-date.svg" />}
                                                                        value={item.value ? dayjs(item.value) : null}
                                                                        onChange={(e) => handleInfoChange(e, index, item.type)}
                                                                    />  : 
                                                                    (
                                                                        item.name === 'SSN' ? <div style={{position: 'relative'}}><Input
                                                                        style={{
                                                                            width: '100%',
                                                                            fontFamily: 'Inter',
                                                                            height: 34,
                                                                            fontSize: 16,
                                                                            color: '#222',
                                                                            padding: '0 6px',
                                                                            borderRadius: '6px',
                                                                            backgroundColor: '#FCFCFC',
                                                                            border: '1px solid #ECECEC'
                                                                        }}
                                                                        disabled={item.name === 'Business name'}
                                                                        value={showSSN ? com.fixSSN(item.value)  : item.value.replace(/(\d{3}-\d{2}-)(\d{4})/g, '*** - ** - $2')}
                                                                        onChange={(e) => handleInfoChange(e, index, item.type)}
                                                                    />{
                                                                        <div style={{position: 'absolute', right: 14, top: 6}} onClick={() => setShowSSN(!showSSN)}>
                                                                            {showSSN ? 
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.77538 0.237027C1.29584 -0.144424 0.604735 -0.056067 0.231759 0.434363C-0.141216 0.924804 -0.0548221 1.63161 0.424721 2.01307L2.93023 4.00609C1.96279 5.11351 1.13371 6.39052 0.460393 7.75803L0.436545 7.80629C0.336094 8.00879 0.206405 8.27035 0.148391 8.59288C0.102246 8.84938 0.102246 9.15066 0.148391 9.40704C0.206405 9.72958 0.336094 9.99114 0.436545 10.1938L0.460393 10.242C2.59404 14.5755 6.29181 18 11.0001 18C13.4544 18 15.6341 17.0694 17.4609 15.5646L20.2246 17.7629C20.7042 18.1444 21.3952 18.0561 21.7682 17.5656C22.1412 17.0752 22.0548 16.3684 21.5753 15.9869L1.77538 0.237027ZM15.6651 14.1361L13.6877 12.5631C12.9443 13.1506 12.0121 13.5 11.0001 13.5C8.56997 13.5 6.60004 11.4852 6.60004 9.00002C6.60004 8.36473 6.72874 7.76028 6.96092 7.21229L4.66912 5.38928C3.81323 6.34471 3.05723 7.48656 2.42532 8.76996C2.39374 8.83408 2.37035 8.88167 2.35062 8.92307C2.33324 8.95952 2.32244 8.98348 2.31539 9.00002C2.32244 9.01656 2.33324 9.04052 2.35062 9.07697C2.37035 9.11837 2.39374 9.16584 2.42532 9.23008C4.35565 13.1506 7.44395 15.75 11.0001 15.75C12.6845 15.75 14.264 15.1667 15.6651 14.1361ZM8.82053 8.69155C8.807 8.79235 8.80007 8.89539 8.80007 9.00002C8.80007 10.2427 9.785 11.25 11.0001 11.25C11.2933 11.25 11.5733 11.1913 11.8291 11.0847L8.82053 8.69155Z" fill="#6E6E70"/>
                                                                                <path d="M10 5.13683L14.9994 9C14.9998 8.97836 15 8.95662 15 8.93497C15 6.76174 13.2267 5 11.0392 5C10.6796 5 10.3311 5.0476 10 5.13683Z" fill="#6E6E70"/>
                                                                                <path d="M19.6919 9.39996C19.312 10.1868 18.8872 10.9216 18.4227 11.594L20.1557 13C20.7172 12.1967 21.2182 11.333 21.6539 10.4305L21.6777 10.3814C21.778 10.175 21.9075 9.90866 21.9654 9.58018C22.0115 9.31908 22.0115 9.01226 21.9654 8.75104C21.9075 8.42256 21.778 8.15619 21.6777 7.94996L21.6539 7.90081C19.5235 3.48757 15.8312 0 11.1301 0C9.24612 0 7.52428 0.560055 6 1.5153L7.89926 3.0562C8.91386 2.5604 9.99826 2.29141 11.1301 2.29141C14.6808 2.29141 17.7644 4.93868 19.6919 8.93137C19.7235 8.99668 19.7469 9.04514 19.7665 9.0873C19.7839 9.12442 19.7946 9.14883 19.8017 9.16567C19.7946 9.18251 19.7839 9.20691 19.7665 9.24403C19.7469 9.2862 19.7235 9.33454 19.6919 9.39996Z" fill="#6E6E70"/>
                                                                            </svg> :
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19" fill="none">
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11 2.69141C7.40678 2.69141 4.28619 5.29082 2.33569 9.21134C2.30378 9.27558 2.28015 9.32306 2.26022 9.36446C2.24265 9.40091 2.23175 9.42487 2.22461 9.44141C2.23175 9.45794 2.24265 9.48191 2.26022 9.51836C2.28015 9.55976 2.30378 9.60723 2.33569 9.67147C4.28619 13.592 7.40678 16.1914 11 16.1914C14.5932 16.1914 17.7138 13.592 19.6643 9.67147C19.6962 9.60723 19.7199 9.55976 19.7398 9.51836C19.7573 9.48191 19.7683 9.45794 19.7754 9.44141C19.7683 9.42487 19.7573 9.40091 19.7398 9.36446C19.7199 9.32306 19.6962 9.27558 19.6643 9.21134C17.7138 5.29082 14.5932 2.69141 11 2.69141ZM0.350225 8.19941C2.50617 3.86594 6.24258 0.441406 11 0.441406C15.7574 0.441406 19.4939 3.86594 21.6497 8.19941C21.6576 8.21516 21.6656 8.23113 21.6739 8.24767C21.7753 8.45028 21.9064 8.71184 21.9651 9.03427C22.0116 9.29077 22.0116 9.59204 21.9651 9.84854C21.9064 10.171 21.7753 10.4326 21.6739 10.6351C21.6656 10.6517 21.6576 10.6677 21.6497 10.6834C19.4939 15.0169 15.7574 18.4414 11 18.4414C6.24258 18.4414 2.50617 15.0169 0.350225 10.6834C0.342434 10.6677 0.334387 10.6517 0.326139 10.6351C0.224638 10.4325 0.093582 10.171 0.034962 9.84854C-0.011654 9.59204 -0.011654 9.29077 0.034962 9.03427C0.093582 8.71184 0.224638 8.45028 0.326139 8.24767C0.334387 8.23113 0.342434 8.21516 0.350225 8.19941ZM11 7.19141C9.77224 7.19141 8.77701 8.19873 8.77701 9.44141C8.77701 10.6841 9.77224 11.6914 11 11.6914C12.2277 11.6914 13.223 10.6841 13.223 9.44141C13.223 8.19873 12.2277 7.19141 11 7.19141ZM6.55405 9.44141C6.55405 6.95612 8.54457 4.94141 11 4.94141C13.4555 4.94141 15.446 6.95612 15.446 9.44141C15.446 11.9266 13.4555 13.9414 11 13.9414C8.54457 13.9414 6.55405 11.9266 6.55405 9.44141Z" fill="#6E6E70"/>
                                                                            </svg>}
                                                                        </div>
                                                                    } </div> 
                                                                    :
                                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                                        <OverflowInput
                                                                        style={{
                                                                            width: '100%',
                                                                            fontFamily: 'Inter',
                                                                            height: 34,
                                                                            fontSize: 16,
                                                                            color: '#222',
                                                                            padding: '0 6px',
                                                                            borderRadius: '6px',
                                                                            backgroundColor: '#FCFCFC',
                                                                            border: '1px solid #ECECEC'
                                                                        }}
                                                                        disabled={item.name === 'Business name1'}
                                                                        value={item.type === 'phone' ? com.fixPhoneInput(item.value) : item.value}
                                                                        onChange={(e) => handleInfoChange(e, index, item.type)}
                                                                    ></OverflowInput> 
                                                                    </div>
                                                                    )
                                                                }
                                                            </div>
                                                            {item.name === 'Business name' && isMatch === -1 && <span className="income-tag">Mismatch with document</span>}
                                                            {item.name === 'SSN' && isMatchSSN === -1 && <span className="income-tag">Mismatch with document</span>}
                                                            {item.name === 'Start date' && isMatchYear === -1 && <span className="income-tag">Mismatch with document</span>}
                                                        </Col>
                                                    </Row>
                                                ))
                                            ) : noData()
                                        }
                                    </div>
                                )}

                                {/* Form 1040 or 1040-SR Schedule C */}
                                {
                                // props.application[currentView].occupation.percentownership > 24 && 
                                (
                                    <div className='income-item'>
                                        <div className='income-item-title'>Form 1040 or 1040-SR Schedule C 
                                            { renderInsufficientHistoryTag(years) }
                                            { renderMissingDocumentTag()}
                                        </div>
                                        {
                                            form1040schedulec.length > 0 ? (
                                                // form1040schedulec.map((item, index) => (
                                                //     <div key={index}>{item.year}</div>
                                                // ))
                                                <div>
                                                    <div className='year-list'>
                                                        <div className="year-item-label"></div> 
                                                        {
                                                            years.map((year, index) => (
                                                                <div key={index} className="year-item-year">{year}</div>
                                                            ))
                                                        }
                                                        <div className="year-item-btn"></div>

                                                    </div>
                                                    {tableData.map((item, index) => (
                                                        <div className='year-list' style={{display: item.deleted ? 'none' : ''}}>
                                                            <div className={item.level === 2 ?  "year-item-label-level2" : 'year-item-label'}>
                                                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                                                    <div style={{flex: 1,overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{item.label}</div>
                                                                    {item.showTooltip && <Tooltip title={item.tooltip} placement="bottom">
                                                                        <div style={{marginLeft: 5}}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                                                                <path d="M6.00008 0.552073C4.50218 0.503838 3.04736 1.09029 1.95409 2.18304C0.860812 3.2758 0.218139 4.78585 0.166748 6.38265C0.218139 7.97945 0.860812 9.4895 1.95409 10.5823C3.04736 11.675 4.50218 12.2615 6.00008 12.2132C7.49798 12.2615 8.9528 11.675 10.0461 10.5823C11.1394 9.4895 11.782 7.97945 11.8334 6.38265C11.782 4.78585 11.1394 3.2758 10.0461 2.18304C8.9528 1.09029 7.49798 0.503838 6.00008 0.552073ZM6.00008 11.2415C4.74385 11.2899 3.52078 10.8058 2.5984 9.89528C1.67603 8.98472 1.12944 7.72175 1.07821 6.38265C1.12944 5.04354 1.67603 3.78058 2.5984 2.87002C3.52078 1.95947 4.74385 1.47544 6.00008 1.52384C7.25631 1.47544 8.47939 1.95947 9.40176 2.87002C10.3241 3.78058 10.8707 5.04354 10.922 6.38265C10.8707 7.72175 10.3241 8.98472 9.40176 9.89528C8.47939 10.8058 7.25631 11.2899 6.00008 11.2415Z" fill="#8A8C90"/>
                                                                                <path d="M5.9863 9.26663C6.29235 9.26663 6.54046 9.0021 6.54046 8.67579C6.54046 8.34949 6.29235 8.08496 5.9863 8.08496C5.68024 8.08496 5.43213 8.34949 5.43213 8.67579C5.43213 9.0021 5.68024 9.26663 5.9863 9.26663Z" fill="#8A8C90"/>
                                                                                <path d="M7.26094 3.85875C6.89975 3.56365 6.45436 3.40994 5.99948 3.4234C5.77991 3.40978 5.55999 3.44274 5.35245 3.52038C5.14492 3.59802 4.95389 3.71879 4.79045 3.87569C4.627 4.0326 4.49438 4.22252 4.40027 4.43446C4.30616 4.6464 4.25243 4.87615 4.24219 5.11039V5.1959H5.14635V5.11816C5.16135 4.8913 5.25901 4.67971 5.41844 4.52862C5.57786 4.37753 5.78641 4.29894 5.99948 4.30965C6.10232 4.2964 6.20663 4.30665 6.30545 4.33974C6.40428 4.37283 6.49537 4.42799 6.57264 4.50154C6.6499 4.5751 6.71159 4.66536 6.75358 4.76632C6.79557 4.86728 6.81689 4.97662 6.81615 5.08706C6.81615 5.35916 6.64115 5.65457 6.2474 5.94999C6.05233 6.06686 5.8851 6.23002 5.75866 6.42684C5.63222 6.62366 5.54995 6.84886 5.51823 7.08501V7.36488H6.4224V7.16275C6.42898 7.01266 6.48895 6.87089 6.5901 6.76627C6.70535 6.62725 6.83227 6.49974 6.96927 6.38534L7.09323 6.2765C7.29622 6.13583 7.46316 5.94349 7.579 5.71683C7.69485 5.49018 7.75594 5.23634 7.75677 4.97823C7.75753 4.76404 7.7134 4.55238 7.62762 4.3587C7.54183 4.16502 7.41656 3.99421 7.26094 3.85875Z" fill="#8A8C90"/>
                                                                            </svg>
                                                                        </div>
                                                                    </Tooltip>}
                                                                </div>
                                                                <div>
                                                                    {
                                                                        item.level !==2 && (
                                                                            item.label === 'Nonrecurring income or loss' ? 
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                                <circle cx="12" cy="12" r="12" fill="#ECECEC"/>
                                                                                <path d="M6 13.0183V10.9819H18V13.0183H6Z" fill="#474849"/>
                                                                            </svg>
                                                                            :
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                                <circle cx="12" cy="12.5" r="12" fill="#ECECEC"/>
                                                                                <path d="M10.9818 18.5V6.5H13.0182V18.5H10.9818ZM6 13.5182V11.4818H18V13.5182H6Z" fill="#474849"/>
                                                                            </svg>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div> 
                                                            <div className="year-item-year">
                                                                {
                                                                    !['Business miles', 'Depreciation rate', 'Amortization/Casualty loss/One-time expenses'].includes(item.label) 
                                                                    ? 
                                                                    
                                                                    <Form form={form}>
                                                                        <Form.Item
                                                                            validateStatus={!['Net profit or loss', 'Nonrecurring income or loss'].includes(item.label) && item.value1 < 0 ? 'warning' : ''}
                                                                            hasFeedback
                                                                            help={!['Net profit or loss', 'Nonrecurring income or loss'].includes(item.label) && item.value1 < 0 ? 'Positive number only.' : ''}
                                                                        >
                                                                            {/* <InputNumber
                                                                            changeOnBlur={true}
                                                                            className='year-item-year-input'
                                                                            value={item.value1} 
                                                                            prefix={item.label === 'Miles' ? '' : <span style={{color: '#6E6E70', height: 17}}>$</span>} 
                                                                            suffix={item.label === 'Miles' ? <span style={{color: '#6E6E70', height: 17}}>miles</span> : ''}
                                                                            formatter={formatDisplayValue}
                                                                            parser={(val) => handleInputValue(val, item.label)}
                                                                            onChange={(val) => handleScheduleCFieldItemChange(index, 'value1', val, item)}
                                                                            onBlur={handleBlur}
                                                                            // onPressEnter={(e) => handleScheduleCFieldItemChange(index, 'value1', e.target.value, item)}
                                                                            
                                                                            />  */}
                                                                        <MoneyInput
                                                                            value={ item.value1 }
                                                                            onBlur={ (val) => handleScheduleCFieldItemChange(index, 'value1', val, item) }
                                                                            isMiles={item.label === 'Miles'} 
                                                                            isEntertainment={item.label === 'Non-deductible meals & entertainment'}
                                                                        >
                                                                        </MoneyInput>
                                                                        </Form.Item>
                                                                    
                                                                    </Form>
                                                                    : <div className="year-item-year-value">{item.label === 'Depreciation rate' ? item.value1 : '$ ' +  addThousandSeparator(item.value1)}</div>
                                                                }
                                                            </div> 
                                                            <div className="year-item-year">
                                                                {
                                                                    !['Business miles', 'Depreciation rate', 'Amortization/Casualty loss/One-time expenses'].includes(item.label) 
                                                                    ? 
                                                                    
                                                                    <Form.Item
                                                                    validateStatus={!['Net profit or loss', 'Nonrecurring income or loss'].includes(item.label) && Number(item.value2) < 0 ? 'warning' : ''}
                                                                    hasFeedback
                                                                    help={!['Net profit or loss', 'Nonrecurring income or loss'].includes(item.label) && Number(item.value2) < 0 ? 'Positive number only.' : ''}
                                                                >
                                                                    
                                                                    <MoneyInput
                                                                            value={ item.value2 }
                                                                            onBlur={ (val) => handleScheduleCFieldItemChange(index, 'value2', val, item) }
                                                                            isMiles={item.label === 'Miles'} 
                                                                            isEntertainment={item.label === 'Non-deductible meals & entertainment'}
                                                                        >
                                                                        </MoneyInput>

                                                                    </Form.Item>
                                                                    : <div className="year-item-year-value">{item.label === 'Depreciation rate' ? item.value2 : '$ ' +  addThousandSeparator(item.value2)}</div>
                                                                }
                                                            </div> 
                                                            <div className="year-item-btn">
                                                                { item.label === 'Amortization/Casualty loss/One-time expenses' 
                                                                ? <div className='year-item-btn-reset' onClick={() => handleReset(item,index)}>Reset</div> 
                                                                : 
                                                                ['Net profit or loss', 'Nonrecurring income or loss', 'Depletion', 'Depreciation', 'Non-deductible meals & entertainment', 'Business use of home', 'Miles' ].includes(item.label) 
                                                                ? <div className='year-item-btn-clear' onClick={() => handleClear(item,index)}>Clear</div> 
                                                                : <div>
                                                                    {
                                                                        !['Business miles', 'Depreciation rate'].includes(item.label) ? 
                                                                        <div className='year-item-btn-delete' onClick={() => handleDelete(item,index)}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                                <path d="M16 8.38281L8 16.3828M8.00001 8.38281L16 16.3828M21 12.3828C21 17.3534 16.9706 21.3828 12 21.3828C7.02944 21.3828 3 17.3534 3 12.3828C3 7.41225 7.02944 3.38281 12 3.38281C16.9706 3.38281 21 7.41225 21 12.3828Z" stroke="#6E6E70" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                            </svg>
                                                                        </div>
                                                                        : ''
                                                                    }
                                                                </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {/* annual total */}
                                                    <div className='year-list' style={{borderTop: '1px solid #ECECEC'}}>
                                                        <div className="year-item-label" style={{ marginTop: 17}} >Annual total</div> 
                                                        {
                                                            years.map((year, index) => (
                                                                <div key={index} className="year-item-year" style={{ marginTop: 17}}>
                                                                    <div className='year-item-year-value'>
                                                                        $ {getTotal(index + 1 )}
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                        <div className="year-item-btn"></div>

                                                    </div>
                                                    <div className='year-list'>
                                                        <div style={{flex: 1, textAlign: 'right'}}>{renderNegativeIncomeTag()}{renderDecliningIncomeTag()}</div>
                                                        <div className="year-item-btn"></div>
                                                    </div>
                                                </div>
                                            ) : noData()
                                        }
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* show document */}
                        <div style={{position: 'relative', display: step === 0 ? 'block' : 'none', flex: 1}} span={12}>
                            <div className='income-preview-wrap'>
                                <div style={{display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 12}}>
                                    <div className='income-calculation-change-file'>
                                        <img className={`prev-file ${getIndexByValue(selectFile) <= 0 && 'arrow-disabled'}`} src={`/images/document-arrow-left${getIndexByValue(selectFile) <= 0 ? '-disabled' : ''}.svg`} onClick={() => changeFile('prev')}/>
                                        <div className='flie-total'>
                                            File <span>{getIndexByValue(selectFile) > -1 ? (getIndexByValue(selectFile) + 1) : 0} / {fileOptions.length}</span>
                                        </div>
                                        <div className='separate'></div>
                                        <div className='file-name'>
                                            {selectFile && selectFile !== '' ? (
                                                <><img src={ getLabelByValue(selectFile)?.substring(getLabelByValue(selectFile).lastIndexOf('.') + 1) === 'pdf' ? '/images/pdf-icon.svg' : '/images/img-icon.svg'}/><div className='file-name-text'>{removeFileExtension(getLabelByValue(selectFile))}</div></>
                                            ) : (
                                                <div className='file-unavailable'><div></div>File unavailable</div>
                                            )}
                                        </div>
                                        <img className={`next-file ${(getIndexByValue(selectFile) < 0 || (getIndexByValue(selectFile) === fileOptions.length - 1)) && 'arrow-disabled'}`} src={`/images/document-arrow-right${(getIndexByValue(selectFile) < 0 || (getIndexByValue(selectFile) === fileOptions.length - 1)) ? '-disabled' : ''}.svg`} onClick={() => changeFile('next')}/>
                                    </div>
                                    <Dropdown
                                        onOpenChange={(visible) => setIsOpen(visible)}
                                        trigger={['click']}
                                        dropdownRender={fileSelectDropdownContent}
                                        placement="bottomRight"
                                    >
                                        <div className='income-calculation-select-file'><img src='/images/income-file.svg'/></div>
                                    </Dropdown>
                                </div>
                                <div className='document-preview-content' ref={containerRef} onScroll={handleScroll}>
                                    <div style={{ width: pageWidth * scale }} className='preview-box'>
                                        {
                                            selectFile && (getLabelByValue(selectFile)?.substring(getLabelByValue(selectFile).lastIndexOf('.') + 1) === 'pdf') ? (
                                                <Document style={{height: '100%'}} error={<Skeleton active />} loading={
                                                     <div style={{marginTop: 200, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                                                        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                                                        <div className='document-preview-loading-text'>It might take about 10 - 20 seconds to read a document. </div>
                                                    </div>
                                                    } 
                                                     file={file} onLoadSuccess={onDocumentLoadSuccess}>
                                                    {Array.from(new Array(numPages), (_, index) => (
                                                        <div
                                                            id={`pdfPage-${index + 1}`}
                                                            key={`page_${index + 1}`}
                                                            data-page={index + 1}
                                                            ref={(ref) => (pageRefs.current[index] = ref)}
                                                            style={{ width: pageWidth * scale }}
                                                            className="pdf-anchor"
                                                        >
                                                            {visiblePages.includes(index + 1) ? (
                                                                <Page
                                                                    loading={<Skeleton active />}
                                                                    renderAnnotationLayer={false}
                                                                    pageNumber={index + 1}
                                                                    width={pageWidth * scale}
                                                                />
                                                            ) : (
                                                                <Skeleton active />
                                                            )}
                                                        </div>
                                                    ))}
                                                </Document>
                                            ) : (
                                                selectFile && <Image
                                                    preview={false}
                                                    width={pageWidth * scale}
                                                    src={createImageURLFromBase64(file, `image/${getLabelByValue(selectFile)?.substring(getLabelByValue(selectFile).lastIndexOf('.') + 1)}` )}
                                                />
                                            )

                                        }
                                    </div>
                                </div>
                                {
                                    fileOptions.length > 0 && (
                                        <div className='document-preview-bottom-bar'>
                                            <div className="document-preview-pagination">
                                                <Pagination size='small' simple current={selectFile && (getLabelByValue(selectFile)?.substring(getLabelByValue(selectFile).lastIndexOf('.') + 1) === 'pdf') ? currentPage : 1} pageSize={1} total={selectFile && (getLabelByValue(selectFile)?.substring(getLabelByValue(selectFile).lastIndexOf('.') + 1) === 'pdf') ? numPages : 1} onChange={onChangePage} />
                                            </div>
                                            <div className="document-preview-scale">
                                                <div className='zoom-min'><MinusOutlined style={{ fontSize: 16 }} onClick={() => changeZoom('min')} /></div>
                                                <div className='zoom-value'>{Math.round(scale * 100)}%</div>
                                                <div className='zoom-add'><PlusOutlined style={{ fontSize: 16 }} onClick={() => changeZoom('add')} /></div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    {/* step 2 -- calculation */}
                    <div style={{display: step === 1 ? 'block' : 'none'}} span={24}>
                        <div style={{padding: '0 16px 16px'}} className='income-calculation-content'>
                            <div style={{marginBottom: 10, paddingLeft: 30}} className='income-item-title'>Select income calculation</div>
                            <div style={{fontFamily: 'Inter', fontSize: 16, lineHeight: '20px', color: '#6E6E70', fontWeight: 500, paddingLeft: 30}}>
                                Review the methods below and select an income calculation result to apply to Form 1003.                       
                            </div>
                            <div className='income-calculation-content-content'>
                                <div style={{display: 'flex',flexDirection: 'column', gap: 10, flex: 2}}>
                                    <div style={{display: 'flex', flexDirection: 'row', gap: 10}}>
                                        <div style={{flex: 1}}>
                                            {
                                                incomeItems.map((item, index) => (
                                                    <div key={index} className='income-calculation-content-item'>
                                                        <div className='income-calculation-content-item-name'>{item.name}</div>
                                                        {
                                                            index === 2 ? 
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <circle cx="12" cy="12" r="12" fill="#ECECEC"/>
                                                                <path d="M6 13.0183V10.9819H18V13.0183H6Z" fill="#474849"/>
                                                            </svg>
                                                            :
                                                            index !== 0 && <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                <circle cx="12" cy="12.5" r="12" fill="#ECECEC"/>
                                                                <path d="M10.9818 18.5V6.5H13.0182V18.5H10.9818ZM6 13.5182V11.4818H18V13.5182H6Z" fill="#474849"/>
                                                            </svg>
                                                        }
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <div className='income-calculation-content-item-line' style={{flex: 1}}>
                                            {selfEmployment.map((yearData, yearIndex) => (
                                                <div key={yearIndex} className="income-calculation-year-column">
                                                    {/* <div className="income-calculation-year-header">{yearData.year}</div> */}
                                                    {incomeItems.map((item, itemIndex) => {
                                                        if (itemIndex === 0) return <div className="income-calculation-year-header">{yearData.year}</div>; // 跳过第一项（空项）
                                                        
                                                        const fieldName = item.name;
                                                        const fieldValue = yearData[fieldName] ? Number(yearData[fieldName]) : 0;
                                                        
                                                        return (
                                                            <div style={{position: 'relative'}}>
                                                            <div key={itemIndex} className="income-calculation-field-row">
                                                                {/* <Form.Item
                                                                        validateStatus={item.name === 'Nonrecurring income or loss' ? (fieldValue > 0 ? 'warning' : '') : (fieldValue < 0 ? 'warning' : '')}
                                                                        hasFeedback
                                                                        help={item.name === 'Nonrecurring income or loss' ? (fieldValue > 0 ? 'Negative number only.' : '') : (fieldValue < 0 ? 'Positive number only.' : '')}
                                                                    > */}
                                                                {/* <Form.Item
                                                                    validateStatus={!['Net profit or loss', 'Nonrecurring income or loss'].includes(item.name) && Number(fieldValue) < 0 ? 'warning' : ''}
                                                                    hasFeedback
                                                                    help={!['Net profit or loss', 'Nonrecurring income or loss'].includes(item.name) && Number(fieldValue) < 0 ? 'Positive number only.' : ''}
                                                                > */}
                                                                <div className="hover-container">
                                                                    <div className="hover-div">
                                                                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M4.05677 13.2727V0.54541H4.87211V13.2727H4.05677ZM6.80109 4.36359C6.74143 3.8598 6.49948 3.46871 6.07524 3.1903C5.651 2.91189 5.13064 2.77268 4.51416 2.77268C4.0634 2.77268 3.66899 2.8456 3.33092 2.99143C2.99617 3.13727 2.73433 3.33779 2.54541 3.593C2.3598 3.8482 2.267 4.13821 2.267 4.46302C2.267 4.7348 2.33163 4.96847 2.46089 5.16402C2.59347 5.35625 2.7625 5.517 2.968 5.64626C3.17349 5.77221 3.38892 5.87661 3.6143 5.95947C3.83968 6.03902 4.04683 6.10365 4.23575 6.15337L5.26984 6.43177C5.53499 6.50138 5.82997 6.59749 6.15479 6.72013C6.48291 6.84276 6.79612 7.01014 7.09442 7.22226C7.39603 7.43106 7.64461 7.69953 7.84016 8.02766C8.0357 8.35578 8.13348 8.75848 8.13348 9.23575C8.13348 9.78594 7.9893 10.2831 7.70095 10.7272C7.41591 11.1714 6.9983 11.5243 6.44811 11.7862C5.90123 12.048 5.2367 12.1789 4.4545 12.1789C3.72533 12.1789 3.09394 12.0613 2.56033 11.826C2.03002 11.5906 1.61241 11.2625 1.30748 10.8416C1.00587 10.4206 0.835183 9.93177 0.79541 9.37496H2.06814C2.10128 9.75943 2.23054 10.0776 2.45592 10.3295C2.68461 10.5781 2.97297 10.7637 3.32098 10.8863C3.6723 11.0056 4.05015 11.0653 4.4545 11.0653C4.92515 11.0653 5.34773 10.9891 5.72226 10.8366C6.09678 10.6808 6.39342 10.4654 6.61217 10.1903C6.83092 9.91189 6.9403 9.58708 6.9403 9.21587C6.9403 8.8778 6.84584 8.6027 6.65692 8.39058C6.468 8.17846 6.21942 8.00611 5.91118 7.87354C5.60294 7.74096 5.26984 7.62496 4.91189 7.52552L3.65905 7.16757C2.86359 6.93888 2.23386 6.61241 1.76984 6.18817C1.30583 5.76392 1.07382 5.20876 1.07382 4.52268C1.07382 3.95261 1.22794 3.45545 1.53618 3.03121C1.84773 2.60365 2.26534 2.27221 2.78902 2.03689C3.31601 1.79825 3.90431 1.67893 4.55393 1.67893C5.21018 1.67893 5.79352 1.79659 6.30393 2.03192C6.81435 2.26392 7.21871 2.58211 7.517 2.98646C7.81861 3.39082 7.9777 3.84986 7.99427 4.36359H6.80109Z" fill="#6E6E70"/>
                                                                        </svg>
                                                                        <div>&nbsp;{formatNumber(fieldValue, item.name)}</div>
                                                                    </div>
                                                                    <div className="hover-input">
                                                                        <MoneyInput
                                                                            value={fieldValue}
                                                                            onBlur={(val) => {
                                                                                console.log('onBlur-------val', val)
                                                                                setSelectedRadio(null)
                                                                                // 重新计算total1 或total2
                                                                                calcTotal(yearIndex)
                                                                                const num = val
                                                                                const updatedScheduleC = [...selfEmployment];
                                                                                updatedScheduleC[yearIndex][fieldName] = num;
                                                                                setSelfEmployment(updatedScheduleC);
                                                                                setLoadingLine({year: yearIndex, line: itemIndex, loading: true, showReset: false})
                                                                                postSelfEmployment(yearIndex)
                                                                            }}
                                                                            onReset={() => {
                                                                                console.log('onReset')
                                                                                resetValue(yearIndex, fieldName)
                                                                            }}
                                                                            isMiles={item.name === 'Miles'}
                                                                            isEntertainment={item.name === 'Non-deductible meals & entertainment'}
                                                                            isPositiveOnly={!['Nonrecurring income or loss', 'Net profit or loss'].includes(item.name)}
                                                                            reShowMode
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {/*<MoneyInput
                                                                    
                                                                    value={fieldValue}
                                                                    onBlur={ (val) => {
                                                                        console.log('onBlur-------val', val)
                                                                        setSelectedRadio(null)
                                                                        // 重新计算total1 或total2
                                                                        calcTotal(yearIndex)
                                                                        const num = val
                                                                        const updatedScheduleC = [...selfEmployment];
                                                                        updatedScheduleC[yearIndex][fieldName] = num;
                                                                        setSelfEmployment(updatedScheduleC);
                                                                        setLoadingLine({year:yearIndex, line: itemIndex, loading: true, showReset: false})
                                                                        postSelfEmployment(yearIndex)
                                                                    } }
                                                                    onReset={() => {
                                                                        console.log('onReset')
                                                                        resetValue(yearIndex, fieldName)
                                                                    }}
                                                                    isMiles={item.name === 'Miles'} 
                                                                    isEntertainment={item.name === 'Non-deductible meals & entertainment'}
                                                                    isPositiveOnly={!['Nonrecurring income or loss', 'Net profit or loss'].includes(item.name)}
                                                                    reShowMode
                                                                >
                                                                </MoneyInput>*/}
                                                                {/* </Form.Item> */}
                                                                {/* <InputNumber
                                                                    variant="borderless"
                                                                    style={{ 
                                                                        '.ant-input-number-handler-wrap': {
                                                                          display: 'none'
                                                                        }
                                                                      }}
                                                                    className="income-calculation-field-input"
                                                                    prefix={
                                                                        <div className="input-prefix">
                                                                            <span>$</span>
                                                                        </div>
                                                                    }
                                                                    addonAfter={
                                                                        isEdit ? (
                                                                            <div 
                                                                                className="input-hover-svg"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault()
                                                                                    e.stopPropagation();
                                                                                    console.log('resetValue-------')
                                                                                    resetValue(yearIndex, fieldName);
                                                                                }}
                                                                            >
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18.5C14.4183 18.5 18 14.9183 18 10.5C18 6.08172 14.4183 2.5 10 2.5C5.58172 2.5 2 6.08172 2 10.5C2 14.9183 5.58172 18.5 10 18.5ZM10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5Z" fill="#6E6E70"/>
                                                                                    <path d="M12.8286 6.25732L14.2428 7.67154L7.17176 14.7426L5.75754 13.3284L12.8286 6.25732Z" fill="#6E6E70"/>
                                                                                    <path d="M14.2427 13.3286L12.8285 14.7428L5.75739 7.67176L7.17161 6.25754L14.2427 13.3286Z" fill="#6E6E70"/>
                                                                                </svg>
                                                                            </div>
                                                                        ) : ''
                                                                    }
                                                                    suffix={
                                                                    !isEdit && <div className="input-hover-svg">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 18 18" fill="none">
                                                                            <path d="M11.6935 2.86019L14.6398 5.80647M12.9435 1.61019C13.7571 0.796602 15.0762 0.796602 15.8898 1.61019C16.7034 2.42379 16.7034 3.74288 15.8898 4.55647L4.41667 16.0296H1.5V13.0537L12.9435 1.61019Z" stroke="#6E6E70" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                        </svg>
                                                                    </div>
                                                                    }
                                                                    min={
                                                                        item.name === 'Nonrecurring income or loss' ? -1000000 : 0
                                                                    }
                                                                    max={
                                                                        item.name === 'Nonrecurring income or loss' ? 0 : 1000000
                                                                    }
                                                                    formatter={(value) => {
                                                                        // 千分位分隔符
                                                                        // console.log('value-------formatter',value)
                                                                        if (value) {
                                                                            const parts = Number(value).toFixed(2).toString().split(".");
                                                                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                                            return parts.join(".") + (parts.length === 1 ? ".00" : parts[1].length === 1 ? "0" : "");
                                                                        }
                                                                        return value;
                                                                    }}
                                                                    parser={(value) => {
                                                                        // console.log('value-------parser',value)
                                                                        return Number(value.toString().replace(/,/g, ""));
                                                                    }}
                                                                    value={fieldValue}
                                                                    // value={fieldValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    onChange={(val) => {
                                                                        !isEdit && setIsEdit(true)
                                                                        const data = {year:yearIndex, line:itemIndex, loading: false, showReset: true}
                                                                        setLoadingLine(data)
                                                                        console.log('onChange-------', val)
                                                                        // 只允许输入正负数
                                                                        const num = Number(val.toString().replace(/[^\d.-]/g, ''))
                                                                        const updatedScheduleC = [...selfEmployment];
                                                                        updatedScheduleC[yearIndex][fieldName] = num;
                                                                        setSelfEmployment(updatedScheduleC);
                                                                        setSelectedRadio(null)
                                                                        // 重新计算total1 或total2
                                                                        calcTotal(yearIndex)
                                                                    }}
                                                                    onPressEnter={(e) => {
                                                                        console.log('onPressEnter-------', e)
                                                                        if(loadingLine.loading) return
                                                                        setIsEdit(false)
                                                                        postSelfEmployment(yearIndex)
                                                                        const data = {year:yearIndex, line:itemIndex, loading: true, showReset: false}
                                                                        setLoadingLine(data)
                    
                                                                    }}
                                                                    onBlur={(e) => {
                                                                        console.log('onBlur-------', e)
                                                                        if(loadingLine.loading) return
                                                                        console.log('blur')
                                                                        setIsEdit(false)
                                                                        postSelfEmployment(yearIndex)
                                                                        setLoadingLine({year:yearIndex, line: itemIndex, loading: true, showReset: false})    

                                                                    }}
                                                                />
                                                                {/* </Form.Item> */}
                                                                {/* {loadingLine.year === yearIndex && loadingLine.line === itemIndex && isEdit && loadingLine.showReset
                                                                && (
                                                                    <div 
                                                                        className="input-hover-svg2"
                                                                        onClick={(e) => {
                                                                            // e.preventDefault()
                                                                            // e.stopPropagation();
                                                                            console.log('resetValue-------')
                                                                            resetValue(yearIndex, fieldName);
                                                                        }}
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18.5C14.4183 18.5 18 14.9183 18 10.5C18 6.08172 14.4183 2.5 10 2.5C5.58172 2.5 2 6.08172 2 10.5C2 14.9183 5.58172 18.5 10 18.5ZM10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5Z" fill="#6E6E70"/>
                                                                            <path d="M12.8286 6.25732L14.2428 7.67154L7.17176 14.7426L5.75754 13.3284L12.8286 6.25732Z" fill="#6E6E70"/>
                                                                            <path d="M14.2427 13.3286L12.8285 14.7428L5.75739 7.67176L7.17161 6.25754L14.2427 13.3286Z" fill="#6E6E70"/>
                                                                        </svg>
                                                                    </div>
                                                                    )
                                                                } */}
                                                                {!isEdit && loadingLine.year === yearIndex && loadingLine.line === itemIndex && loadingLine.loading && <Spin style={{marginLeft: 10}} indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />}
                                                                {!isEdit && loadingLine.year === yearIndex && loadingLine.line === itemIndex && !loadingLine.loading && <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                                                <rect x="8" y="14.2422" width="2" height="8" rx="1" transform="rotate(-45 8 14.2422)" fill="#325CEB"/>
                                                                <rect x="20.7285" y="10" width="2" height="12" rx="1" transform="rotate(45 20.7285 10)" fill="#325CEB"/>
                                                                </svg>}
                                                            </div>
                                                            <div style={{color: '#cb8600', fontSize: 10, fontWeight: 400,lineHeight: '16px', marginLeft: 12, zIndex: 9, position: 'absolute', bottom: -13, left: 0}}>
                                                                {['Depletion', 'Depreciation', 'Non-deductible meals & entertainment', 'Business use of home', 'Business miles', 'Amortization/Casualty loss/One-time expenses'].includes(item.name) ? ( fieldValue < 0 ? 'Positive number only.' : '') : ''}
                                                            </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <div className='income-calculation-content-footer'>
                                            <div className='income-calculation-content-footer-left'>
                                                <div className='income-calculation-content-footer-left-item income-calculation-content-item-name'>Annual total</div>
                                                <div className='income-calculation-content-footer-left-item'>
                                                    <div className='income-calculation-content-footer-left-item-content'>                                        
                                                        <span>
                                                            $ {total1}
                                                        </span>
                                                        {/* {selfEmployment.length > 1 &&  */}
                                                        <span>
                                                            $ {total2}
                                                        </span>
                                                        {/* } */}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='income-calculation-content-footer-right'>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div style={{flex: 1}}>
                                    <div className='income-calculation-card'>
                                        <div className='income-calculation-card-title'>Results
                                            { renderInsufficientHistoryTag(years) }
                                            { renderNegativeIncomeTag2() }
                                            { renderDecliningIncomeTag2() }
                                        </div>
                                        <div className='income-calculation-card-1003-input'>
                                            <div className='income-calculation-card-1003-input-title'>Current 1003 input</div>
                                            <div className='income-calculation-card-1003-input-content'>$ { current1003Input }</div>
                                        </div>
                                        <Radio.Group value={selectedRadio} onChange={onRadioChange}>
                                            <Radio value={1}>
                                                <div className='income-calculation-card-item'>
                                                    <div className='income-calculation-card-item-title'>
                                                        <span>Monthly income:</span> 
                                                        <span className='income-calculation-card-item-title-content'>most recent year average</span>  
                                                    </div>
                                                    <div className='income-calculation-card-item-content'>$ {mostRecentYearAverage}</div>
                                                </div>
                                            </Radio>
                                            {!form1040schedulec.find(item => item.year === '-') && <Radio value={2} style={{marginTop: 20}}>
                                                <div className='income-calculation-card-item'>
                                                    <div className='income-calculation-card-item-title'>
                                                        <span>Monthly income:</span> 
                                                        <span className='income-calculation-card-item-title-content'>two years average</span>  
                                                    </div>
                                                    <div className='income-calculation-card-item-content'>$ {twoYearsAverage}</div>
                                                </div>
                                            </Radio>}
                                        </Radio.Group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}
